/* eslint-disable camelcase */
import { isLoggedInOrRemembered } from '../../utils/isLoggedIn';

// I'm not certain which fields could actually be undefined, but this interface makes our code work
interface MbsyCookie {
    mbsy_short_code?: string;
    mbsy_campaign_uid: string;
}
type callbackType = typeof setShortCodeToInputFields;

export const getAmbassadorShortCode = function (callback: callbackType) {
    callback = callback || setShortCodeToInputFields;
    const mbsy_cookie = b64DecodeUnicodeCookieIfPossibleAndFix('dc_mbsy_cookie', 90);
    if (!mbsy_cookie) {
        return;
    }

    const mbsy_cookie_obj = JSON.parse(mbsy_cookie);
    const mbsy_short_code = mbsy_cookie_obj.mbsy_cookie_code;
    const mbsy_campaign_uid = mbsy_cookie_obj.mbsy_cookie_campaign;

    if (mbsy_short_code && mbsy_campaign_uid) {
        const data = {
            mbsy_short_code,
            mbsy_campaign_uid,
        };
        callback(data);
    }
};

// Used by ready.js
export const updateAmbassadorMbsyCookie = function () {
    const uri = new Uri(location.href);
    const mbsy_source_param = uri.getParam('mbsy_source');
    const mbsy_param = uri.getParam('mbsy');
    const campaignid_param = uri.getParam('campaignid');
    if (mbsy_source_param && mbsy_param && campaignid_param) {
        const mbsy_cookie = {
            mbsy_cookie_campaign: campaignid_param,
            mbsy_cookie_code: mbsy_param,
            mbsy_source: mbsy_source_param,
        };
        window.createCookie('dc_mbsy_cookie', window.b64EncodeUnicode(JSON.stringify(mbsy_cookie)), 90);
    }
};

function setShortCodeToInputFields(data: MbsyCookie) {
    if (data.mbsy_short_code) {
        $('#ambassadorShortCode').val(data.mbsy_short_code);
        $('#ambassadorCampaignId').val(data.mbsy_campaign_uid);
    }
}

function b64DecodeUnicodeCookieIfPossibleAndFix(cookieName: string, days?: number) {
    const str = window.readCookie(cookieName);
    if (str) {
        try {
            return window.b64DecodeUnicode(str);
        } catch (e) {
            window.createCookie('cookieName', window.b64EncodeUnicode(str), days);
            // return undecoded
            return str;
        }
    }
    return null;
}

export const shouldShowAmbassadorBanner = function () {
    return window.readCookie('dc_mbsy_cookie') !== null &&
            isLoggedInOrRemembered() &&
            window.isUserTypeTeacher() &&
            window.userObj &&
            typeof window.userObj.hasSubmittedAProject !== 'undefined' &&
            !window.userObj.hasSubmittedAProject;
};
